/** Контейнер тостов. Живёт в Providers, монтируется один раз на приложение. */

import { useEffect } from 'react'

import { haptic } from '@/shared/telegram'
import { Icon } from '@/shared/ui/Icon'
import { useToastStore, type Toast } from '@/shared/ui/toast'

export function ToastHost() {
  const toasts = useToastStore((state) => state.toasts)
  const dismiss = useToastStore((state) => state.dismiss)

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex flex-col items-center gap-2 px-4 pb-[calc(var(--tabbar-height)+var(--tabbar-gap)+var(--safe-bottom)+12px)]">
      {toasts.map((item) => (
        <ToastItem key={item.id} toast={item} onDismiss={() => dismiss(item.id)} />
      ))}
    </div>
  )
}

function ToastItem({ toast: item, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, item.durationMs)
    return () => window.clearTimeout(timer)
  }, [item.durationMs, onDismiss])

  return (
    <div
      role="status"
      className="bg-toast text-toast-text pop pointer-events-auto flex w-full max-w-[420px] items-center gap-3 rounded-[var(--radius-button)] px-4 py-3 text-[15px] shadow-[var(--shadow-raised)]"
    >
      {/*
        Тон тоста виден только по значку, а значок скрыт от скринридера.
        Слово рядом держит смысл в тексте, который зачитает role="status".
      */}
      {item.tone === 'success' && (
        <>
          <Icon name="state-success" size={22} />
          <span className="sr-only">Готово.</span>
        </>
      )}
      {item.tone === 'error' && (
        <>
          <Icon name="state-warning" size={22} />
          <span className="sr-only">Ошибка.</span>
        </>
      )}
      <span className="min-w-0 flex-1">{item.text}</span>
      {item.onUndo && (
        <button
          type="button"
          className="tap-target text-toast-action shrink-0 font-semibold"
          onClick={() => {
            haptic('select')
            item.onUndo?.()
            onDismiss()
          }}
        >
          {item.undoLabel}
        </button>
      )}
    </div>
  )
}
